/**
 * Computes a normalized, truncated preview string for TXT content.
 * Collapses whitespace, trims edges, and slices to a maximum length.
 *
 * @param raw - Original text content to preview
 * @param maxLength - Maximum number of characters to keep (default 150)
 * @returns Preview string
 *
 * @example
 * computeTxtPreview('Hello   world', 5) // 'Hello'
 */
export function computeTxtPreview(raw: string | null | undefined, maxLength = 150): string {
  const normalized = String(raw ?? '')
    .replace(/\s+/g, ' ')
    .trim();
  return normalized.slice(0, maxLength);
}
